window.currentLocale = function () {
    return document.querySelector('meta[name="locale"]')?.getAttribute('content');
};
